import type { FactionDefinition } from '../../factions';

export interface ShipSkin {
  readonly primary: number;
  readonly primaryDark: number;
  readonly hull: number;
  readonly hullDark: number;
  readonly accent: number;
  readonly trim: number;
  readonly cockpit: number;
  readonly cockpitGlow: number;
  readonly glow: number;
  readonly plasma: number;
  readonly strobe: number;
}

export function buildShipSkin(
  faction: FactionDefinition,
  chosenPrimary: number
): ShipSkin {
  return {
    ...faction.palette,
    primary: chosenPrimary,
    primaryDark: darken(chosenPrimary, 0.45)
  };
}

function darken(hex: number, factor: number): number {
  const r = Math.floor(((hex >> 16) & 0xff) * factor);
  const g = Math.floor(((hex >> 8) & 0xff) * factor);
  const b = Math.floor((hex & 0xff) * factor);
  return (r << 16) | (g << 8) | b;
}
